/**
 * @fileoverview GET handler for the "/companies/:company_id/custom_domains/:domain_type/:domain_id/subscription_groups" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createGetFetcherFunctionWithShadowError";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdCustomDomainsDomainTypeDomainIdSubscriptionGroups } from "./constants";
import type {
  CompaniesCompanyIdCustomDomainsDomainTypeDomainIdSubscriptionGroupsParams,
  CompaniesCompanyIdCustomDomainsDomainTypeDomainIdSubscriptionGroupsResult,
  CompaniesCompanyIdCustomDomainsDomainTypeDomainIdSubscriptionGroupsResultErrors,
} from "./types";
import { isCompaniesCompanyIdCustomDomainsDomainTypeDomainIdSubscriptionGroupsResult } from "./validators";

export const getCompaniesCompanyIdCustomDomainsDomainTypeDomainIdSubscriptionGroups = reactQueryFetcherAdapter(
  companiesCompanyIdCustomDomainsDomainTypeDomainIdSubscriptionGroups,
  createGetFetcherFunctionWithShadowError<CompaniesCompanyIdCustomDomainsDomainTypeDomainIdSubscriptionGroupsResultErrors>()(
    (
      signal: AbortSignal,
      { companyId, domainType, domainId }: CompaniesCompanyIdCustomDomainsDomainTypeDomainIdSubscriptionGroupsParams
    ): Promise<CompaniesCompanyIdCustomDomainsDomainTypeDomainIdSubscriptionGroupsResult> => {
      return fetch(
        `/companies/${companyId}/custom_domains/${domainType}/${domainId}/subscription_groups`,
        "GET",
        undefined,
        { signal },
        {
          // The deletion modal renders encoded errors inline.
          propagateFetchRequestError: false,
        }
      );
    }
  ),
  isCompaniesCompanyIdCustomDomainsDomainTypeDomainIdSubscriptionGroupsResult
);
